import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelectMultiple } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';


const CountryGroupsInput: InputWithSource = ({ input }) => <GenericSelectMultiple label={input.name} input={input} />;

CountryGroupsInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(CountryGroupsInput);
